module.exports = "/static/Images/pt-br/Five.png";